// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const obstagoon: PokeData = {
  "id": 862,
  "name": "obstagoon",
  "height": 16,
  "weight": 460,
  "base_experience": 260,
  "types": [
    PokeType.DARK,
    PokeType.NORMAL
  ],
  "api_moves": [
    "sand-attack",
    "headbutt",
    "tackle",
    "take-down",
    "double-edge",
    "pin-missile",
    "leer",
    "submission",
    "counter",
    "lick",
    "fury-swipes",
    "rest",
    "scary-face",
    "cross-chop",
    "taunt",
    "night-slash",
    "switcheroo",
    "hone-claws",
    "snarl",
    "baby-doll-eyes",
    "obstruct"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "pin-missile",
    "leer",
    "lick",
    "scary-face",
    "cross-chop",
    "night-slash",
    "snarl",
    "quash",
    "supersonic",
    "protect",
    "dark-bargain"
  ],
  "evolution_chain": {
    "id": 134,
    "item": null,
    "species": [
      {
        "name": "zigzagoon",
        "order": 288,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "linoone",
        "order": 289,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 263,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "obstagoon",
        "order": 862,
        "types": [
          PokeType.DARK,
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 264,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "night",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 133,
    "speed": 137,
    "ability_power": 130
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
